import cn from 'clsx';
import { forwardRef, HTMLAttributes, ReactNode } from 'react';

import { FieldsetLabel } from './FieldSetLabel';
import { FieldsetSupportText } from './FieldSetSupportText';

export interface FieldsetProps extends HTMLAttributes<HTMLDivElement> {
  isInvalid?: boolean;
  label?: ReactNode;
  supportText?: string;
  errorMessage?: string;
}

export const Fieldset = forwardRef<HTMLDivElement, FieldsetProps>(({ isInvalid, supportText, errorMessage, label, children, className, ...props }, ref) => {
  return (
    <div className={cn('w-full pb-normal-medium pt-tiny-medium', className)} ref={ref} {...props}>
      {label && <FieldsetLabel label={label} />}
      {children}
      {((isInvalid && errorMessage) || supportText) && (
        <FieldsetSupportText supportText={isInvalid && errorMessage ? errorMessage : supportText!} isInvalid={isInvalid} />
      )}
    </div>
  );
});

Fieldset.displayName = 'Fieldset';
